import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Form, useForm } from "@portal/BaseComponents/Form/AntForm";
import { StyledFormItem } from "@portal/BaseComponents/Form/style";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { FormFooter } from "@portal/BaseComponents/UI/FormArea/FormFooter";
import { FormHeader } from "@portal/BaseComponents/UI/FormArea/FormHeader";
import { Modal } from "@portal/BaseComponents/Modal/AntModal";
import { CommentForm } from "../CommentFormComponents";

interface CommentModalProps {
  open: boolean;
  onClose: () => void;
  getUpdatedValues?: (value: string) => void;
  value?: string;
  title?: React.ReactNode;
  placeholder?: string;
}

function CommentModal(props: CommentModalProps) {
  const { open, onClose, getUpdatedValues, value, title, placeholder } = props;
  const [form] = useForm<{ comment: string }>();
  const Heading = <>{title}</>;

  function handleSubmit() {
    form.validateFields().then(() => {
      const values = form.getFieldsValue();

      getUpdatedValues?.(values.comment);
    });
  }
  const HeaderTitle = (
    <Flex align="center" justify="start">
      <TypographyText fs="20">Comment</TypographyText>
    </Flex>
  );

  const Header = (
    <FormHeader title={HeaderTitle} onClose={onClose} mode="modal" />
  );
  const Footer = (
    <FormFooter
      saveButtonProps={{ onClick: handleSubmit, text: "Add" }}
      cancelButtonProps={{ onClick: onClose }}
    />
  );
  const CommentArea = (
    <StyledFormItem
      label="Add Comment"
      required
      name="comment"
      initialValue={value}
      style={{ width: "100%" }}
      preserve={false}
      rules={[{ required: true, message: "This Field is Required" }]}
    >
      <CommentForm placeholder={placeholder} />
    </StyledFormItem>
  );
  return (
    <Modal
      open={open}
      title={Header}
      footer={Footer}
      closable={false}
      maskClosable
      centered
      destroyOnClose
      onCancel={onClose}
      mask
      styles={{
        body: {
          overflow: "auto",
          maxHeight: "600px",
        },
      }}
    >
      <Flex space="24" vertical>
        {Heading}
        <Form form={form} layout="vertical" style={{ width: "100%" }}>
          {CommentArea}
        </Form>
      </Flex>
    </Modal>
  );
}

export { CommentModal };
